<template>
  <div class="motor-selection">
    <div class="container-x">
      <div class="step step-1 flex-wrap">
        <div class="d-flex flex-column">
          <div class="step-title">
            {{ $t('powerpack.steps.step1.name') }}
          </div>
          <div class="d-flex flex-column flex-sm-row">
            <div class="flex-column" >
              <app-label :label="$t('powerpack.steps.step1.pressure')" tooltip-key="tooltip_pressure"/>
              <codd-input-number
                  class="mx-sm-3"
                  :unit="$t('powerpack.steps.step1.bar')"
                  :val="pressure"
                  @focus="pushDataLayer({
                    step: gaData.steps.step1,
                    interaction_type: gaData.interactionTypes.click,
                    field: 'werkdruk',
                    build_id: this.gaData.undefined,
                    value: this.gaData.undefined,
                  })"
                  @codd_input="setPressure"
              >
              </codd-input-number>
            </div>
            <div class="flex-column">
              <app-label :label="$t('powerpack.steps.step1.volumetricFlow')" tooltip-key="tooltip_power"/>
              <codd-input-number
                  class="mx-sm-3"
                  :unit="$t('powerpack.steps.step1.lpm')"
                  :val="liters"
                  @codd_input="setLiters"
                  @focus="pushDataLayer({
                    step: gaData.steps.step1,
                    interaction_type: gaData.interactionTypes.click,
                    field: 'volumestroom',
                    build_id: gaData.undefined,
                    value: gaData.undefined,
                  })"
              >
              </codd-input-number>
            </div>
            <div class="flex-column">
              <app-label :label="$t('powerpack.steps.step1.power')" tooltip-key="tooltip_total_flow"/>
              <codd-input-number
                  class="mx-sm-3"
                  :unit="$t('powerpack.steps.step1.kw')"
                  :val="power"
                  @codd_input="setPower"
                  @focus="pushDataLayer({
                    step: gaData.steps.step1,
                    interaction_type: gaData.interactionTypes.click,
                    field: 'vermogensbeheer',
                    build_id: gaData.undefined,
                    value: gaData.undefined,
                  })"
              >
              </codd-input-number>
            </div>
          </div>
        </div>

        <div class="flex-column">
          <div class="step-title">
            {{ $t('powerpack.steps.step1.open_build') }}
          </div>

          <search-build></search-build>
        </div>
      </div>

      <div class="step step-2">
        <div class="step-title">
          {{ $t('powerpack.steps.step2.name') }}
        </div>
        <motor-picker></motor-picker>
      </div>

      <div class="step step-3" v-if="checkSelection">
        <div class="step-title">
          {{ $t('powerpack.steps.step3.name') }}
        </div>
        <div class="row">
          <motor-option
              v-for="(option, key) in options"
              :name="option.name"
              :tooltip-key="option.tooltip"
              :slug="key"
              :key="key"
          ></motor-option>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLabel from '../input/Label';
import MotorPicker from './picker/MotorPicker';
import MotorOption from './MotorOption';
import CoddInputNumber from '../input/Number';
import {mapState} from 'vuex';
import tooltipMixin from "../../mixins/tooltipMixin";
import axios from "axios";
import SearchBuild from "@/components/build/SearchBuild.vue";
import googleAnalyticsMixin from '@/mixins/googleAnalyticsMixin';

export default {
  name: 'StepPowerPack',

  mixins: [
    tooltipMixin,
    googleAnalyticsMixin
  ],

  components: {
    SearchBuild,
    AppLabel,
    MotorPicker,
    MotorOption,
    CoddInputNumber,
  },
  watch: {
    liters() {
      this.calcPower();
    },
    pressure() {
      this.calcPower();
    }
  },
  computed: {
    ...mapState({
      liters: state => state.preference.liters,
      pressure: state => state.preference.pressure,
      power: state => state.preference.power,
    }),

    options() {
      return {
        mini_powerpack: {
          name: this.$t('powerpack.steps.step3.mini_powerpack'),
          tooltip: 'tooltip_mini_powerpack',
        },
        workplace: {
          name: this.$t('powerpack.steps.step3.workplace'),
          tooltip: 'tooltip_workplace',
        },
        and_pump: {
          name: this.$t('powerpack.steps.step3.and_pump'),
          tooltip: 'tooltip_motor_and_pump',
        },
        open_frame: {
          name: this.$t('powerpack.steps.step3.open_frame'),
          tooltip: 'tooltip_open_frame_powerpack',
        },
        closed_frame: {
          name: this.$t('powerpack.steps.step3.closed_frame'),
          tooltip: 'tooltip_closed_frame_powerpack',
        },
        industrial: {
          name: this.$t('powerpack.steps.step3.industrial'),
          tooltip: 'tooltip_industrial_powerpack',
        },
      };
    },
    available() {
      return this.$store.state.preference.selectedMotor && this.$store.state.preference.selectedMotor[this.slug];
    },
    checkSelection() {
      return this.$store.state.preference.selectedMotorGroup;
    },
    selectedMotor() {
      return this.$store.state.preference.selectedMotor;
    }
  },

  methods: {
    setPower(val) {
      this.$store.dispatch('preference/updatePower', val);
      this.$store.commit('preference/resetMotorSelection');
    },
    setPressure(val) {
      this.$store.dispatch('preference/updatePressure', val);
      this.$store.commit('preference/resetMotorSelection');
    },
    setLiters(val) {
      this.$store.commit('preference/updateLiters', val);
      this.$store.commit('preference/resetMotorSelection');
    },
    calcPower() {
      let power = ((this.liters * this.pressure) / 540).toFixed(1);

      this.setPower(power);
    },
    onInputChange() {
      this.$store.commit('preference/resetMotorOptions')
    },
  },
  mounted() {
    this.$store.dispatch('build/resetState');
  }
}
</script>

<style lang="scss">
.motor-selection {
  background-color: #F5F5F5;
}

.step {
  padding: 20px 30px 20px 0;
  border-radius: 5px;

  @media only screen and (max-width: 768px) {
    padding: 20px 0;
    max-width: 600px;
    margin: 0 auto;
  }

  .step-title {
    padding-bottom: 20px;
    font-size: 20px;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    font-style: normal;
  }

  &.step-1 {
    display: flex;
  }
}

.sub-title {
  font-family: neue-haas-grotesk-display, sans-serif;
  font-size: 14px;
  font-weight: 700;
}

.inputs {
  max-width: 800px;
  margin: 0 auto;
  justify-content: space-around;
}

.input-container {


  @media only screen and (max-width: 576px) {
    width: 100%;
    max-width: 270px;
    margin: 10px auto 10px 0;
  }

  & span.unit {
    right: 60px;
    padding: 0 12px;
  }
}

.magento {
  .motor-selection {
    padding-top: 0;
  }
}
</style>
